import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { navModule } from './modules/nav';
import { homeModule } from './modules/home';
import { themeModule } from './modules/theme';
import { authModule } from './modules/auth';
import {
  catalogModule,
  catalogGraphModule,
  catalogIndexModule,
} from './modules/catalog';
import { errorsModule } from './modules/errors';
import npmPlugin from '@backstage-community/plugin-npm/alpha';
import todoPlugin from '@backstage-community/plugin-todo/alpha';
import githubActionsPlugin from '@backstage-community/plugin-github-actions/alpha';
import githubIssuesPlugin from '@backstage-community/plugin-github-issues/alpha';
import cicdStatisticsPluginGithubModule from '@backstage-community/plugin-cicd-statistics-module-github/alpha';
import githubPullRequestsPlugin from '@backstage-community/plugin-github-pull-requests-board/alpha';
import techInsightsPlugin from '@backstage-community/plugin-tech-insights/alpha';
import techInsightsMaturityPlugin from '@backstage-community/plugin-tech-insights-maturity/alpha';
import rybbitAnalyticsModule from '@internal/plugin-analytics-module-rybbit';
import { litellmPlugin } from '@internal/plugin-litellm';
import { llmChatPlugin } from '@internal/plugin-llm-chat';
import { railwayPlugin } from '@internal/plugin-railway';
import { rybbitPlugin } from '@internal/plugin-rybbit';
import { sandboxedPlugin } from '@internal/plugin-sandboxed';

export default createApp({
  features: [
    catalogPlugin,
    navModule,
    themeModule,
    homeModule,
    authModule,
    catalogModule,
    catalogGraphModule,
    catalogIndexModule,
    errorsModule,
    rybbitAnalyticsModule,
    npmPlugin,
    todoPlugin,
    githubActionsPlugin,
    githubIssuesPlugin,
    githubPullRequestsPlugin,
    cicdStatisticsPluginGithubModule,
    techInsightsPlugin,
    techInsightsMaturityPlugin,
    litellmPlugin,
    llmChatPlugin,
    railwayPlugin,
    rybbitPlugin,
    sandboxedPlugin,
  ],
});
